import { render } from "./PackContent.vue?vue&type=template&id=ef4b3a50"
import script from "./PackContent.vue?vue&type=script&lang=js"
export * from "./PackContent.vue?vue&type=script&lang=js"

import "./PackContent.vue?vue&type=style&index=0&id=ef4b3a50&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__